import config from "../config/firebase"

import app from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import * as storage from "firebase/storage"

import { clearSessStorage } from "../helpers/sessionStorage"

class Firebase {
  constructor() {
    app.initializeApp(config)
    this.auth = app.auth()
    this.db = app.firestore()
    this.storage = storage
  }
  signIn = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password)
  signOut = () => {
    this.auth.signOut()
    clearSessStorage("current_organization_id")
    return (window.location = "/")
  }
  sendPasswordResetEmail = (email, actions) => {
    this.auth.sendPasswordResetEmail(email, actions)
  }
}

export default Firebase